import { ResolvedPermissionResolution } from '@acre/graphql'

export const mergePermissions = (
  existing: readonly ResolvedPermissionResolution[] = [],
  incoming: readonly ResolvedPermissionResolution[],
) => {
  if (!existing) {
    return incoming
  }

  const merged: ResolvedPermissionResolution[] = [...existing]

  for (let i = 0; i < incoming.length; i++) {
    const existingIndex = merged.findIndex((el) => {
      return (
        el.gate === incoming[i].gate &&
        el.scope?.id === incoming[i].scope?.id &&
        el.scope?.type === incoming[i].scope?.type &&
        el.permission_name === incoming[i].permission_name &&
        el.assignee?.id === incoming[i].assignee?.id
      )
    })

    if (existingIndex !== -1) {
      merged[existingIndex] = incoming[i]

      continue
    }

    merged.unshift(incoming[i])
  }

  return merged
}